import { useAsync } from 'react-use';
import * as Sentry from '@sentry/react';

import api from '../api/axios';
import authorizationHeader from '../api/token';

// GET learning paths of a course (paginated)
export function useGetLearningPaths(courseId, page, limit) {
  const { value, loading, error } = useAsync(
    () => getLearningPaths(courseId, page, limit),
    [courseId, page, limit]
  );
  return [value, loading, error];
}

export const getLearningPaths = async (courseId, page = 1, limit = 20) => {
  const token = await authorizationHeader();
  const response = await api
    .get(`/courses/${courseId}/learning-paths?page=${page}&limit=${limit}`, {
      headers: token,
    })
    .then(res => res)
    .catch(err => {
      Sentry.captureException(err);
      if (err?.response?.data) {
        Sentry.captureMessage(err.response.data);
      }
      return err;
    });
  return response.data;
};

// POST create a learning path
export const postLearningPath = async (courseId, payload) => {
  const token = await authorizationHeader();
  const response = await api
    .post(`/courses/${courseId}/learning-paths`, payload, {
      headers: token,
    })
    .then(res => res)
    .catch(err => {
      Sentry.captureException(err);
      if (err?.response?.data) {
        Sentry.captureMessage(err.response.data);
      }
      return err;
    });
  return response;
};

// PUT create a learning path
export const putLearningPath = async (courseId, learningPathId, payload) => {
  const token = await authorizationHeader();
  const response = await api
    .put(`/courses/${courseId}/learning-paths/${learningPathId}`, payload, {
      headers: token,
    })
    .then(res => res)
    .catch(err => {
      Sentry.captureException(err);
      if (err?.response?.data) {
        Sentry.captureMessage(err.response.data);
      }
      return err;
    });
  return response;
};

// GET a single learning path with its resources
export function useGetLearningPath(courseId, learningPathId) {
  const { value, loading, error } = useAsync(
    () => getLearningPath(courseId, learningPathId),
    [courseId, learningPathId]
  );
  return [value, loading, error];
}

export const getLearningPath = async (courseId, learningPathId) => {
  const token = await authorizationHeader();
  const response = await api
    .get(`/courses/${courseId}/learning-paths/${learningPathId}`, {
      headers: token,
    })
    .then(res => res)
    .catch(err => {
      Sentry.captureException(err);
      if (err?.response?.data) {
        Sentry.captureMessage(err.response.data);
      }
      return err;
    });
  return response.data;
};

// DELETE a learning path
export const deleteLearningPath = async (courseId, learningPathId) => {
  const token = await authorizationHeader();
  const response = await api
    .delete(`/courses/${courseId}/learning-paths/${learningPathId}`, {
      headers: token,
    })
    .then(res => res)
    .catch(err => {
      Sentry.captureException(err);
      if (err?.response?.data) {
        Sentry.captureMessage(err.response.data);
      }
      return err;
    });
  return response;
};
